export function getActiveSerial() {
    return localStorage.getItem("activeDeviceSerial");
}

export function setActiveSerial(serial) {
    localStorage.setItem("activeDeviceSerial", serial);

    window.dispatchEvent(
        new CustomEvent("active-device-changed", {
            detail: serial
        })
    );
}